import { createWhiteLabelQuery, whiteLabelServices } from "@mozioinc/query";
import { z } from "zod";
import {
  defaultWhiteLabelData,
  mapWhiteLabelInjectData,
} from "../../scripts/white-label.js";
import { getEnvs } from "./env.js";
import type { ParkingWhiteLabelInjectData } from "../../scripts/white-label.js";

const envSchema = z
  .enum(["production", "staging"])
  .nullable()
  .optional()
  .default("staging")
  .transform((val) => val ?? "staging");

const getWhiteLabelFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    domain: params.get("wl"),
    env: envSchema.parse(params.get("wlEnv")),
  };
};

// TODO: temporary solution
const injectWhiteLabelScript = (name: string) => {
  return new Promise((resolve, reject) => {
    const scriptEl = document.createElement("script");
    scriptEl.setAttribute(
      "src",
      whiteLabelServices.getBootstrapJsUrl(getWhiteLabelFromUrl().env, name),
    );
    scriptEl.addEventListener("load", resolve);
    scriptEl.addEventListener("error", reject);
    document.head.append(scriptEl);
  });
};

const setDevelopAndPreviewWhiteLabel = async () => {
  const domains = ["mozio"];
  const domain = location.hostname.split(".").at(-2)!;
  if (!domains.includes(domain)) {
    console.info(
      "App not rendered under mozio domain. You can test white label by setting 'wl' and 'wlEnv' URL search parameters (e.g. wl=tui.mozio.com&wlEnv=production)",
    );

    const { domain: whiteLabelDomain } = getWhiteLabelFromUrl();

    if (!whiteLabelDomain) {
      const { config, themeVars } = defaultWhiteLabelData;
      setCssVariables(themeVars);
      window.WHITE_LABEL_CONFIG = config;
      return;
    }

    await injectWhiteLabelScript(whiteLabelDomain);
    if (!window.WL_OBJ) {
      console.error("window.WL_OBJ not found!");
      return;
    }
    window.WL_OBJ.defaultDomain = whiteLabelDomain;

    const whiteLabelDomainData = whiteLabelServices
      .getWhiteLabelDomains(window.WL_OBJ)
      .find((d) => d.domain === whiteLabelDomain)!;

    const { config, themeVars } = mapWhiteLabelInjectData(whiteLabelDomainData);
    window.WHITE_LABEL_CONFIG = config;
    setCssVariables(themeVars);
  }
};

const setCssVariables = (theme: Record<string, string>) => {
  const root = document.documentElement;
  Object.entries(theme).forEach(([property, value]) => {
    root.style.setProperty(property, value);
  });
};

export const setWhiteLabel = async () => {
  if (getEnvs().VERCEL_ENV === "production") {
    return;
  }
  await setDevelopAndPreviewWhiteLabel();
};

export const getWhiteLabel = (): ParkingWhiteLabelInjectData["config"] => {
  if (!window.WHITE_LABEL_CONFIG) {
    console.error("window.WHITE_LABEL_CONFIG not found!");
    return defaultWhiteLabelData.config;
  }
  return window.WHITE_LABEL_CONFIG;
};
